import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { XaltInputBase, XaltToolTip, constants, XaltInputAdornment, XaltIconButton, XaltClear } from 'xalt-react-atoms';

const { input: { XALT_INPUT_TYPES } } = constants;

/**
 * A platform component for building a text label
 */
export default class RWTextField extends Component {
    static propTypes = {
        style: PropTypes.object,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
            PropTypes.bool,
        ]),
        tipText: PropTypes.string,
        isReadMode: PropTypes.bool,
        isFocused: PropTypes.bool,
        onValueChanged: PropTypes.func,
        xStyle: PropTypes.object,
        maxLength: PropTypes.number,
        regxValidationPattern: PropTypes.string,
        type: PropTypes.oneOf([
            XALT_INPUT_TYPES.EMAIL,
            XALT_INPUT_TYPES.NUMBER,
            XALT_INPUT_TYPES.PASSWORD,
            XALT_INPUT_TYPES.TEXT,
        ]),
        propertyRef: PropTypes.object,
    };

    static defaultProps = {
        style: {},
        type: XALT_INPUT_TYPES.TEXT,
    };

    constructor(props) {
        super(props);
        this.textRef = props.propertyRef || React.createRef();
    }

    render() {
        // Get children prop for text
        const {
            style,
            value,
            tipText,
            isReadMode,
            isFocused,
            onValueChanged,
            xStyle,
            type,
            regxValidationPattern,
            maxLength } = this.props;

        // const {
        //     input,
        //     underline,
        //     autoGrow } = xStyle || { input: {}, underline: {}, autoGrow: true };
        const {
            input,
            clearIcon = {},
            nonSaltPropertyBGColor = {},
        } = xStyle || { input: {} };
        const nonSaltPropBGColor = isReadMode ? {} : nonSaltPropertyBGColor;
        const componentStyle = {
            ...nonSaltPropBGColor,
            ...style,
            ...input,
        };
        const {
            display,
            flexGrow,
            flexShrink,
            width,
            height } = style;
        const tipStyle = {
            display: display || 'flex',
            flexGrow,
            flexShrink,
            width,
            height,
        };
        return (
            <XaltToolTip
                style={ tipStyle }
                tipText={ tipText }>
                <XaltInputBase
                    style={ { display: 'flex', textOverflow: 'ellipsis', ...componentStyle } }
                    endAdornment={ this.renderEndAdornment(isReadMode, clearIcon, value) }
                    disabled={ isReadMode }
                    maxLength={ maxLength }
                    multiline={ false }
                    onValueChanged={ onValueChanged }
                    readOnly={ isReadMode }
                    value={ value ?? '' }
                    type={ type }
                    regxValidationPattern={ regxValidationPattern }
                    autoFocus={ isFocused }
                    inputRef={ this.textRef } />
            </XaltToolTip>
        );
    }

    renderEndAdornment(isReadOnly, iconStyle, value) {
        const { fontSize } = iconStyle;
        return (
            <XaltInputAdornment style={ { visibility: (isReadOnly || !value) ? 'hidden' : 'visible' } }>
                <XaltIconButton
                    onClick={ this.handleOnClearClick }
                    style={ iconStyle }>
                    <XaltClear
                        style={ { fontSize } } />
                </XaltIconButton>
            </XaltInputAdornment>
        );
    }

    handleOnClearClick = () => {
        const { onValueChanged } = this.props;
        this.textRef.current.focus();
        onValueChanged('');
    }
}
